import { FunctionComponent, KeyboardEvent, MouseEvent } from "react";

/** Určuje styl otevření */
export enum OpenOn {
    click = "click",
    hover = "hover",
    clickAndHover = "clickAndHover",
}

/**
 * Typ pro Dropdown trigger renderer properties.
 */
export type DropdownTriggerRendererProps = {
    onClick: (e: MouseEvent) => void;
    onKeyDown: (e: KeyboardEvent) => void;
};

/**
 * Typ rendereru pro trigger Dropdownu. Pro správné fungování musí custom renderer
 * předat **všechny** properties (onClick, onKeyDown, ...).
 */
export type DropdownTriggerRenderer = FunctionComponent<DropdownTriggerRendererProps>;
